/**
 * @file 律临 ubc 打点封装
 * @author dingzhenyue
 */

import {UbcLogger} from '@baidu/ubc-report-sdk';

export const initUbcLog = () => {
    let _UbcLogger = null;
    try {
        _UbcLogger = new UbcLogger({
            serverId: 11230,
            testMode: process.env.NODE_ENV === 'development',
            page: 'lvlin', // 默认值
            source: 'saas-pc',
            from: 'lvlin',
            version: '2.0'
        });
    }
    catch (e) {}
    return _UbcLogger;
};
